export default Object.freeze([
    {
        label: 'ASAP',
        value: 'asap',
    },
    {
        label: 'In 24-48 hours',
        value: 'in24to48hours',
    },
    {
        label: 'Within 7 days',
        value: 'within7days',
    },
])
